import { __awaiter } from "tslib";
import { get } from 'svelte/store';
import { AppState } from '../etc/stores';
import { Backend } from './backend';
import { Container, Service } from './container';
export class CodeVerification extends Service {
    constructor() {
        super(...arguments);
        this.backend = this.ctx.get(Backend);
    }
    sendCodeToTarget(target, type = 'email', context = 'customer-verify-account') {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.backend.codeVerificationRequestTarget(type, {
                target,
                validate: false,
                context
            });
            return response.id;
        });
    }
    sendCodeToCustomer(customerId, type = 'email', context = 'customer-verify-account') {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.backend.codeVerificationRequestCustomer({
                type,
                context,
                customerId
            });
            return response.id;
        });
    }
    validateCode(code, type = 'email', codeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { website } = get(AppState);
            const id = codeId || website.codeId;
            if (id) {
                const response = yield this.backend.codeVerificationValidate(id, {
                    code,
                    type
                });
                return response.access_token;
            }
        });
    }
}
Container.add(CodeVerification);
